//3rd Party Components
import React from 'react';
import queryString from 'query-string';
import AUpageAlert from '@gov.au/page-alerts';
import AuPageAlert from '../DTA/AuPageAlert/AuPageAlert';
import { useSelector } from "react-redux";

const ProcessMessage = () => {

    let params = window.location.search;
    let parsed = queryString.parse(params);

    let userdetails = useSelector(state => state.userdetails);

    let msgsignout = null;
    let msgmessage = null;
    let msgerr = null;
    let msgwarn = null;
    let msgsavesuccess = null;
    let msgprofilesavesuccess = null;
    let msgemailsavesuccess = null;
    let msgtimeout = null;
    let msgdraftdeleted = null;
    let msgdroneregdeleted = null;
    let msgdronereged = null;
    let msgappdeleted = null;
    let msgemailupdated = null;
    let msgphoneupdated = null;
    let msgaddressupdated = null;
    let msgnoexamresult = null;
    let msgweightclassupdated = null;

    let msg = false;
    if (parsed.noexamresult !== undefined && parsed.noexamresult === "1") {
        msgnoexamresult = (<AuPageAlert as="warning"
            title='Exam result not available'
            message='Please wait for email notification of your result' />
        );
        msg = true;
    }

    if (parsed.addressupdated !== undefined && parsed.addressupdated === "1") {
        msgaddressupdated = (<AuPageAlert as="success"
            title='Your address details have been saved' />
        );
    }

    if (parsed.phoneupdated !== undefined && parsed.phoneupdated === "1") {
        msgphoneupdated = (<AuPageAlert as="success"
            title='Your phone details have been saved' />
        );
        msg = true;
    }

    if (parsed.emailupdated !== undefined && parsed.emailupdated === "1") {
        msgemailupdated = (<AuPageAlert as="success"
            title='Your email details have been saved' />
        );
        msg = true;
    }

    if (parsed.droneregdeleted !== undefined && parsed.droneregdeleted === "1") {
        msgdroneregdeleted = (<AuPageAlert as="success"
            title='Application deleted'
            message='Your drone registration application has been deleted' />
        );
        msg = true;
    }

    if (parsed.draftdeleted !== undefined && parsed.draftdeleted === "1") {
        msgdroneregdeleted = (<AuPageAlert as="success"
            title='Saved application deleted'
            message='Your saved application has been deleted' />
        );
        msg = true;
    }

    if (parsed.dronedereged !== undefined && parsed.dronedereged === "1") {
        msgdronereged = (<AuPageAlert as="success"
            title='Drone de-registered'
            message={'A confirmation of your de-registration has been sent to your email address ' + userdetails.items.value[0].emailaddress1} />
        );
        msg = true;
    }

    if (parsed.appdeleted !== undefined && parsed.appdeleted === "1") {
        msgappdeleted = (<AuPageAlert as="success"
            title='Application cancelled'
            message='Your application has been cancelled' />
        );
        msg = true;
    }

    if (parsed.signout !== undefined && parsed.signout === "1") {
        msgsignout = (<AuPageAlert as='info'
            title='You have been signed out' />
        );
        msg = true;
    }

    if (parsed.msg !== undefined && parsed.msg !== "") {
        msgmessage = (<AuPageAlert as="success"
            title={parsed.msg} />
        );
        msg = true;
    }

    if (parsed.err !== undefined && parsed.err !== "") {
        msgerr = (<AuPageAlert as="error"
            title={parsed.err} />
        );
        msg = true;
    }

    if (parsed.warn !== undefined && parsed.warn !== "") {
        msgwarn = (<AuPageAlert as="warning"
            title={parsed.warn} />
        );
        msg = true;
    }

    if (parsed.saveSuccess !== undefined && parsed.saveSuccess !== "") {
        msgsavesuccess = (<AuPageAlert as="info"
            title='This form has been saved'
            message={<div><p>The information on this form <b>has not been completed</b> and sent to CASA.</p><p /><p>Information saved on this form will be kept for seven days. After this time it will be deleted.</p></div>} />
        );
        msg = true;
    }

    if (parsed.profileSaveSuccess !== undefined && parsed.profileSaveSuccess !== "") {
        msgprofilesavesuccess = (<AuPageAlert as="success"
            title={parsed.profileSaveSuccess} />
        );
        msg = true;
    }

    if (parsed.emailSaveSuccess !== undefined && parsed.emailSaveSuccess !== "") {
        msgemailsavesuccess = (<AuPageAlert as="success"
            title={parsed.emailSaveSuccess} />
        );
        msg = true;
    }

    if (parsed.timedout !== undefined && parsed.timedout !== "") {
        msgtimeout = (<AuPageAlert as="info"
            title='You have been signed out'
            message='For security reasons you have been signed out due to inactivity' />
        );
        msg = true;
    }

    if (parsed.weightClassUpdated !== undefined && parsed.weightClassUpdated === "1") {
        msgweightclassupdated = (<AuPageAlert as="success"
            title='Weight class saved successfully'
            message='Please note: The weight class of your drone will not be updated until you have completed the declaration below and submitted this form.' />
        );
        msg = true;
    }

    return msg ?
        <div className="body container" id="msg" >
            <div className="row">
                
                    <br />
                    <div id="message">
                        {msgsignout}
                        {msgmessage}
                        {msgerr}
                        {msgwarn}
                        {msgsavesuccess}
                        {msgprofilesavesuccess}
                        {msgemailsavesuccess}
                        {msgtimeout}
                        {msgdroneregdeleted}
                        {msgdronereged}
                        {msgappdeleted}
                        {msgemailupdated}
                        {msgphoneupdated}
                        {msgaddressupdated}
                        {msgnoexamresult}
                        {msgweightclassupdated}
                    </div>
                    <br />
                
            </div>
        </div>
        : null

}

export default ProcessMessage;